import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-webinar01',
  templateUrl: './webinar01.component.html',
  styleUrls: ['./webinar01.component.scss']
})
export class Webinar01Component implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("How to Use AI to Improve Your Academic Writing");
    this.metaTagService.updateTag({ name: 'description', content: "Our aim with the session is to guide researchers in choosing between AI assistance and content generation for academic publishing workflows." });
    this.metaTagService.updateTag({ property: 'og:title', content: "How to Use AI to Improve Your Academic Writing" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Our aim with the session is to guide researchers in choosing between AI assistance and content generation for academic publishing workflows." });
    this.metaTagService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.metaTagService.updateTag({ name: 'twitter:site', content: '@thetrinkaai' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "How to Use AI to Improve Your Academic Writing" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Our aim with the session is to guide researchers in choosing between AI assistance and content generation for academic publishing workflows." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/webinars/how-to-use-ai-to-improve-your-academic-writing' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/webinars/how-to-use-ai-to-improve-your-academic-writing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/webinars/how-to-use-ai-to-improve-your-academic-writing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/webinars/how-to-use-ai-to-improve-your-academic-writing' });
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

  stopAllVideos() {
    const iframes = document.querySelectorAll('iframe.youtubeVideoForTryDemo');
    iframes.forEach((iframe: HTMLIFrameElement) => {
      iframe.src = iframe.src; // Setting src to the same value pauses the video
    });
  }

  

}
